import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../routes/routes'
import userApi, { UserResetPasswordRequest } from '../apis/user.api'
import alertService from '../services/alert.service'
import AuthCard from '../components/AuthCard'
import Button from '../components/Button'
import InputText from '../components/InputText'
import Page from '../components/Page'

interface Props extends RouteComponentProps {}

interface State {
  email: string
}

class ResetPassword extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      email: '',
    }
  }

  handleInputChange = (name: string, value: string) => {
    if (name === 'email') this.setState({ email: value })
  }

  handleResetPasswordClick = () => {
    const { email } = this.state
    const payload: UserResetPasswordRequest = {}
    if (email) payload.email = email
    userApi.resetPassword(payload, result => {
      if (!result || !result.sent) return
      const message = 'We have sent you an email with password update link'
      alertService.success(message)
      this.props.history.push(routes.signIn)
    })
  }

  render () {
    return (
      <Page size='half' wrapperClass="pt-20">
        <AuthCard
          heading='Reset password'
          description='Reset your QPRO+ password'>
          <InputText
            label={i18n("Email")}
            name="email"
            value={this.state.email}
            onChange={this.handleInputChange} />
          <Button
            text={i18n("Reset password")}
            full={true}
            onClick={this.handleResetPasswordClick} />
        </AuthCard>
      </Page>
    )
  }
}

export default withRouter(ResetPassword)
